import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import '../styles/success.scss';

function Success() {
  const service = useSelector((state) => state.service);
  const history = useHistory();

  if (!service.success) {
    history.push('/');
  }
  return (
    <div className="container success-container">
      <h1>{service.event ? 'Thanks!' : 'Du har bokat en service'}</h1>
      {service.event ? (
        <p>You will receive more details via email shortly.</p>
      ) : (
        <>
          <p className="details m-0 p-0 mt-3 ">{`${
            service?.user?.address?.value ?? service?.shop?.address
          }, ${service?.user?.address?.postcode ?? service?.shop?.postcode}`}</p>
          <p className="details">
            {moment(service.booking.date).format('D MMMM') +
              ', ' +
              service.booking.service_slot_name}
          </p>
          <div className="line" />
          <p className="info">
            Vi har även skickat en bekräftelse med detaljer och mer info till din e-postadress.
          </p>
        </>
      )}
    </div>
  );
}

export default Success;
